import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { Collections, StaticDocuments } from "../utils/collections";
import { Category } from "@/models/category";

export async function getCategories(): Promise<Category[]> {
  const categoriesDoc = await getDoc(
    doc(db, Collections.STATIC, StaticDocuments.CATEGORIES) , 
  );

  const data = categoriesDoc.data()?.["data"];
  if (data) return data as Category[];
  return [];
}